import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Plan, ProductFactory, Simo } from '@bytel/bytel-sales';

import { TextWithLinkDirective } from '../../../../../../app/common/directives/text-with-link.directive';
import { CmsBlockComponent, TrustHtmlPipe } from '../../../../../../app/common/public-api';

@Component({
    selector: 'checkout-byou-card-pepites',
    standalone: true,
    imports: [TextWithLinkDirective, CmsBlockComponent, TrustHtmlPipe],
    templateUrl: './byou-card-pepites.component.html',
    styleUrl: './byou-card-pepites.component.scss',
})
export class ByouCardPepitesComponent {
    @Input() public plan: Plan;
    @Input() public isLocked: boolean;
    @Output() public lockedToggleEvent = new EventEmitter<boolean>();

    public isDarwin: boolean = false;
    public title: string;
    public cmsBlockId: string;
    public internationalCallsCmsBlockId: string = 'mobiles/banniere_forfaits-mobiles_destinations';
    public showInternationalCallsList: boolean = false;

    public ngOnInit(): void {
        this.isDarwin = this.plan.data.is_darwin;

        if (ProductFactory.Is(this.plan, Simo, true)) {
            const btlId = this.plan.data.data_envelope.replace(/ /g, '_').replace(/à/g, 'a').toLowerCase();
            this.cmsBlockId = `mobiles/simo/popin-${btlId}`;
        }

        if (this.isDarwin) {
            this.title = 'Le forfait qui grandit avec votre ado...';
        } else {
            this.title = this.plan.data?.low_prices_wall
                ? "L'essentiel pour bien communiquer..."
                : 'Le plein de gigas, mais pas seulement...';
        }
    }

    public lockedToggle(): void {
        this.isLocked = !this.isLocked;
        this.lockedToggleEvent.emit(this.isLocked);
    }

    public toggleInternationalCall(value: boolean): void {
        this.showInternationalCallsList = value;
    }
}
